import { render, staticRenderFns } from "./question-groups.vue?vue&type=template&id=3be5f183&"
import script from "./question-groups.vue?vue&type=script&lang=js&"
export * from "./question-groups.vue?vue&type=script&lang=js&"
import style0 from "./question-groups.vue?vue&type=style&index=0&id=3be5f183&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports